"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayCompareChanges = function (userDrilledReserves, sourceDrilledReserves, filter) {
    if (userDrilledReserves === void 0) { userDrilledReserves = []; }
    if (sourceDrilledReserves === void 0) { sourceDrilledReserves = []; }
    if (filter === void 0) { filter = ''; }
    var findUSI = function (find) { return function (item) { return item.usi === find.usi; }; };
    // const filterName = item => item.name.toLowerCase().includes(filter.toLowerCase())
    var filterText = function (item) { return item.text.toLowerCase().includes(filter.toLowerCase()); };
    var sortString = function (a, b) {
        if (a.usi > b.usi)
            return 1;
        if (b.usi > a.usi)
            return -1;
        return 0;
    };
    var removeDup = function (prev, current) {
        if (prev.find(findUSI(current)))
            return prev;
        return prev.concat(current);
    };
    return userDrilledReserves.concat(sourceDrilledReserves)
        .map(function (i) {
        var userReserve = userDrilledReserves.find(function (r) { return r.usi === i.usi; });
        var sourceReserve = sourceDrilledReserves.find(function (r) { return r.usi === i.usi; });
        return {
            usi: i.usi,
            text: i.name,
            isAdd: !userReserve,
            isRemove: !sourceReserve,
            compareText: gentextCompare(userReserve, sourceReserve)
        };
    })
        .filter(filterText)
        .sort(sortString)
        .reduce(removeDup, []);
};
/// Save flow
exports.hasDrilledReservesValue = function (drilledReserves) { return (drilledReserves && drilledReserves.sands && drilledReserves.sands.length); };
exports.hasDrilledReserves = function (userDrilledReserves, sourceDrilledReserves) { return (exports.hasDrilledReservesValue(userDrilledReserves) || exports.hasDrilledReservesValue(sourceDrilledReserves)); };
exports.getDrilledReserves = function (userDrilledReserves, sourceDrilledReserves) {
    if (sourceDrilledReserves) {
        if (userDrilledReserves) {
            return userDrilledReserves;
        }
        else {
            return sourceDrilledReserves;
        }
    }
    else if (userDrilledReserves) {
        // has only user's version, this should not be happened actually
        return userDrilledReserves;
    }
    else {
        // has neither user nor source version
        return null;
    }
};
exports.hasIncomingChange = function (userDrilledReserves, sourceDrilledReserves) { return (userDrilledReserves && sourceDrilledReserves && new Date(sourceDrilledReserves.sorUpdatedDate) > new Date(userDrilledReserves.activityDate)); };
exports.gasToLiquid = function (gasInMMScf) { return gasInMMScf / 6; };
exports.liquidToGas = function (liquidInMBOE) { return liquidInMBOE * 6; };
exports.gasAndOilTotal = function (liquidInMBOE, gasInMMScf) { return liquidInMBOE + exports.gasToLiquid(gasInMMScf); };
exports.convertGasAndOilRatio = function (totalInMBOE, liquidRatio) { return ({
    liquidInMBOE: totalInMBOE * liquidRatio,
    gasInMMScf: exports.liquidToGas(totalInMBOE - (totalInMBOE * liquidRatio))
}); };
function gentextCompare(userReserve, sourceReserve) {
    if (!userReserve && !sourceReserve)
        return '';
    var changes = [];
    var listProperties = ['baseMD', 'topTVDSS', 'netGasVT', 'netOilVT', 'avgSw', 'avgPor', 'fluid', 'estPhase', 'remarks', 'azi', 'dataSource'];
    for (var _i = 0, listProperties_1 = listProperties; _i < listProperties_1.length; _i++) {
        var prop = listProperties_1[_i];
        var userVal = userReserve ? userReserve[prop] : '';
        if (userVal == null)
            userVal = '';
        var sourceVal = sourceReserve ? sourceReserve[prop] : '';
        if (sourceVal == null)
            sourceVal = '';
        if (typeof userVal === 'number') {
            userVal = userVal.toFixed(2);
        }
        if (typeof sourceVal === 'number') {
            sourceVal = sourceVal.toFixed(2);
        }
        if (userVal != sourceVal) {
            changes.push(prop + " changed: \"" + String(userVal) + "\" -> \"" + String(sourceVal) + "\"");
        }
    }
    return changes.length ? changes.join('\n') : '';
}
exports.gentextCompare = gentextCompare;
//# sourceMappingURL=wellSummary.js.map